const ERRORS = {
  connection: "Something went wrong with the connection. Please try again later."
};

export default ERRORS;
